var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import PropTypes from "prop-types";
import React, { Component } from "react";
import { GlobalContext } from "./../../../wix-rich-content-common";
import BlockSpoilerComponent from "../BlockSpoilerComponent";
class SpoilerViewerWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasSpoiler: props.componentData?.config?.spoiler?.enabled || false
    };
  }
  componentWillReceiveProps(props) {
    const hasSpoiler = props.componentData?.config?.spoiler?.enabled || false;
    this.setState({ hasSpoiler });
  }
  render() {
    const { hasSpoiler } = this.state;
    const type = this.props.type.toLowerCase();
    const pluginType = type[0].toUpperCase() + type.slice(1);
    const { children } = this.props;
    const { isMobile, t } = this.context;
    return hasSpoiler ? /* @__PURE__ */ React.createElement(BlockSpoilerComponent, { pluginType, isMobile, t, ...this.props }, children) : children;
  }
}
__publicField(SpoilerViewerWrapper, "contextType", GlobalContext);
__publicField(SpoilerViewerWrapper, "propTypes", {
  children: PropTypes.node,
  componentData: PropTypes.object,
  type: PropTypes.string
});
export {
  SpoilerViewerWrapper as default
};
//# sourceMappingURL=SpoilerViewerWrapper.js.map
